import React from "react";

import Project from "./project";

import PROJECTS from "../../data/projects";

import "./styles/allProjects.css";

const AllProjects = () => {
	return (
		<div className="all-projects-container">
			{PROJECTS.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						details={project.details}
						screen={project.screen}
						tools={project.tools}
						title={project.title}
						description={project.description}
						linkText={project.linkText}
						link={project.link}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;
